import React, { useEffect, useState } from 'react';
import api from './api';
import { fileUrl, formatFileSize, userDisplayName } from './helpers';

function AttachmentsPanel({ projectId, taskId, users, currentUser, deliverablesOnly, global, label, emptyLabel, tasksById }) {
  const [attachments, setAttachments] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  const load = () => {
    const params = global
      ? { scope: 'global' }
      : taskId
      ? { taskId }
      : { projectId, deliverablesOnly: deliverablesOnly ? 'true' : undefined };
    api.get('/attachments', { params }).then((res) => setAttachments(res.data)).catch(() => {});
  };

  useEffect(load, [projectId, taskId, global, deliverablesOnly]);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    setError('');

    // IMPORTANT : les champs texte doivent être ajoutés AVANT le fichier dans le
    // FormData pour que le backend (multer) puisse les lire au moment de choisir
    // le dossier de destination (organisation par projet).
    const formData = new FormData();
    if (projectId) formData.append('project_id', projectId);
    if (taskId) formData.append('task_id', taskId);
    if (currentUser?.id) formData.append('uploaded_by', currentUser.id);
    if (label) formData.append('label', label);
    formData.append('file', file);

    try {
      await api.post('/attachments', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      load();
    } catch (err) {
      setError("Impossible d'envoyer le fichier.");
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer ce document ?')) return;
    try {
      await api.delete(`/attachments/${id}`);
      setAttachments(attachments.filter((a) => a.id !== id));
    } catch (err) {
      setError('Impossible de supprimer le document.');
    }
  };

  return (
    <div>
      {error && <div className="error-message" style={{ marginBottom: 10 }}>{error}</div>}

      {attachments.length === 0 && (
        <div style={{ fontSize: 12.5, color: 'var(--text-muted)', marginBottom: 10 }}>
          {emptyLabel || 'Aucun document.'}
        </div>
      )}

      <div className="comments-list" style={{ marginTop: 0 }}>
        {attachments.map((a) => (
          <div key={a.id} className="comment-item">
            <div className="avatar">📄</div>
            <div className="comment-bubble">
              <a href={fileUrl(a.stored_name)} target="_blank" rel="noreferrer" className="comment-author" style={{ textDecoration: 'none' }}>
                {a.original_name}
              </a>
              <span className="comment-time">{formatFileSize(a.size)}</span>
              <div className="comment-text">
                Ajouté par {userDisplayName(users.find((u) => u.id === a.uploaded_by))}
                {tasksById && (
                  <>
                    {' · '}
                    {a.task_id && tasksById[a.task_id] ? (
                      <span style={{ color: 'var(--secondary)' }}>Tâche : {tasksById[a.task_id].name}</span>
                    ) : (
                      <span className="badge badge-todo" style={{ padding: '1px 8px' }}>Livrable projet</span>
                    )}
                  </>
                )}
              </div>
              <span className="comment-delete" onClick={() => handleDelete(a.id)}>Supprimer</span>
            </div>
          </div>
        ))}
      </div>

      <label className="btn btn-sm" style={{ marginTop: 12, display: 'inline-block', cursor: 'pointer' }}>
        {uploading ? 'Envoi...' : '+ Ajouter un document'}
        <input type="file" onChange={handleFileChange} disabled={uploading} style={{ display: 'none' }} />
      </label>
    </div>
  );
}

export default AttachmentsPanel;
